import { c as _c } from "react/compiler-runtime";
// Ontologies: the package manager. The page lists the installed packages (base ones marked) and what the registry
// offers; a package opens in the panel (?pkg=<name>) with its kinds (fields, relations, record counts) and Install /
// Upgrade, which first shows the diff preview (add-only: anything else is refused) and, when the package brings
// hooks, asks for the owner's consent (Decision chat-federation: behaviour by consent). "Install from JSON" takes a
// package the registry does not offer (a private <owner>.<ontology>): pasted or read from a file, same preview and
// consent, installed into this instance only.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useHome } from "@/components/settings";
import { Loader } from "@/components/loader";
import { api, type Package, type PackageDiff, shortKind } from "@/api";
import { ErrorLine } from "@/components/error-line";
import { Group, Item, Stack } from "@/components/group";
import { LinkButton } from "@/components/link-button";
import { Row } from "@/components/row";
import { SectionHead } from "@/components/section-head";
import { useLoad } from "@/lib/load";
import { emitLive } from "@/live/bus";
import { errorText } from "@/store";
const ONTOLOGY_KINDS = ["Ontology", "Package", "Kind", "Field", "Relation", "Rule"];

/** `instance`: a connected instance's installed packages, read-only (no registry, no install). */
export function OntologiesPage(t0) {
  const $ = _c(49);
  const {
    selected,
    onOpen,
    instance
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== instance) {
    t1 = () => api.ontologies.list(instance);
    $[0] = instance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      kinds: ONTOLOGY_KINDS
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const pkgs = useLoad(t1, `packages:${instance ?? ""}`, t2);
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== onOpen || $[4] !== pkgs.data || $[5] !== pkgs.loading || $[6] !== selected || $[7] !== t) {
    const installed = (pkgs.data ?? []).filter(_temp);
    const offered = (pkgs.data ?? []).filter(_temp2);
    let t12;
    if ($[17] !== onOpen || $[18] !== selected) {
      t12 = p_1 => <li key={p_1.name}><Row t="package-row" id={p_1.name} label={<span className="thread-label"><span className="mono">{p_1.name}</span>{p_1.description && <span className="muted last">{p_1.description}</span>}</span>} count={p_1.installed ? `${p_1.installed}${p_1.base ? " · base" : ""}` : p_1.version} aria-pressed={selected === p_1.name} onClick={() => onOpen(p_1.name)} /></li>;
      $[17] = onOpen;
      $[18] = selected;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    const row = t12;
    t3 = "page list";
    t4 = "ontologies";
    t5 = "ontologies";
    if ($[20] !== t) {
      t6 = t("nav.ontologies");
      $[20] = t;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t7 = pkgs.loading || undefined;
    let t13;
    if ($[22] !== t) {
      t13 = t("nav.ontologies");
      $[22] = t;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    if ($[24] !== t13) {
      t8 = <div className="head" data-t="head"><h1 data-t="title">{t13}</h1></div>;
      $[24] = t13;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    let t14;
    if ($[26] !== t) {
      t14 = t("ontologies.installed");
      $[26] = t;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    if ($[28] !== t14) {
      t9 = <SectionHead>{t14}</SectionHead>;
      $[28] = t14;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    const t15 = installed.map(row);
    if ($[30] !== t15) {
      t10 = <ul className="rows">{t15}</ul>;
      $[30] = t15;
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    t11 = offered.length > 0 && <><SectionHead>{t("ontologies.available")}</SectionHead><ul className="rows">{offered.map(row)}</ul></>;
    $[3] = onOpen;
    $[4] = pkgs.data;
    $[5] = pkgs.loading;
    $[6] = selected;
    $[7] = t;
    $[8] = t10;
    $[9] = t11;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t10 = $[8];
    t11 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t12;
  if ($[32] !== instance || $[33] !== onOpen) {
    t12 = !instance && <InstallJson onInstalled={onOpen} />;
    $[32] = instance;
    $[33] = onOpen;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== pkgs.error) {
    t13 = pkgs.error && <ErrorLine>{pkgs.error}</ErrorLine>;
    $[35] = pkgs.error;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t3 || $[42] !== t4 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t14 = <section className={t3} data-t={t4} data-page={t5} aria-label={t6} aria-busy={t7}>{t8}{t9}{t10}{t11}{t12}{t13}</section>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
    $[41] = t3;
    $[42] = t4;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  return t14;
}

/** Install from JSON: a package pasted or read from a file → dry-run preview → (consent) → install. */
function _temp2(p_0) {
  return !p_0.installed;
}
function _temp(p) {
  return p.installed;
}
function InstallJson({
  onInstalled
}: {
  onInstalled: (name: string) => void;
}) {
  const {
    t
  } = useTranslation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [diff, setDiff] = useState<PackageDiff | null>(null);
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const parse = (): Record<string, unknown> | null => {
    try {
      const p = JSON.parse(text) as Record<string, unknown>;
      if (!p || typeof p !== "object" || typeof p.name !== "string") throw new Error(t("ontologies.jsonNoName"));
      return p;
    } catch (e) {
      setError(errorText(e));
      return null;
    }
  };
  const preview = async () => {
    setError(null);
    const p_0 = parse();
    if (!p_0) return;
    try {
      setDiff(await api.ontologies.preview(String(p_0.name), String(p_0.version ?? ""), p_0));
    } catch (e_0) {
      setError(errorText(e_0));
    }
  };
  const install = async () => {
    const p_1 = parse();
    if (!p_1) return;
    setBusy(true);
    setError(null);
    try {
      await api.ontologies.install(String(p_1.name), String(p_1.version ?? ""), consent, p_1);
      setDiff(null);
      setText("");
      setOpen(false);
      emitLive("truss.Ontology", String(p_1.name));
      onInstalled(String(p_1.name));
    } catch (e_1) {
      setError(errorText(e_1));
    } finally {
      setBusy(false);
    }
  };
  return <>
			<SectionHead>{t("ontologies.fromJson")}</SectionHead>
			{!open ? <Group>
					<li>
						<Row t="from-json" label={t("ontologies.fromJsonOpen")} chevron onClick={() => setOpen(true)} />
					</li>
				</Group> : <div className="pkg-json" data-t="pkg-json">
					<textarea data-t="pkg-json-text" rows={8} spellCheck={false} placeholder={'{ "name": "michael.medical", "version": "0.1.0", "requires": ["truss"], "kinds": [ … ] }'} aria-label={t("ontologies.fromJson")} value={text} onChange={e_2 => {
        setText(e_2.target.value);
        setDiff(null);
      }} />
					<input type="file" accept=".json,application/json" data-t="pkg-json-file" onChange={e_3 => {
        const f = e_3.target.files?.[0];
        if (f) void f.text().then(s => (setText(s), setDiff(null)));
      }} />
					{!diff && <Group>
							<li>
								<Row t="json-preview" label={t("ontologies.install")} chevron disabled={!text.trim()} onClick={() => void preview()} />
							</li>
						</Group>}
					{diff && <DiffBlock diff={diff} consent={consent} setConsent={setConsent} busy={busy} label={t("ontologies.install")} onClose={() => setDiff(null)} onInstall={() => void install()} />}
				</div>}
			{error && <ErrorLine>{error}</ErrorLine>}
		</>;
}

/** The dry-run plan: added lines, refusals, the hooks consent and the Install/Upgrade button. */
function DiffBlock(p) {
  const $ = _c(33);
  const {
    t
  } = useTranslation();
  const {
    diff
  } = p;
  const t0 = p.onClose;
  let t1;
  if ($[0] !== t) {
    t1 = t("panel.close");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== p.onClose || $[3] !== t1) {
    t2 = <LinkButton onClick={t0}>{t1}</LinkButton>;
    $[2] = p.onClose;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = diff.from ?? "∅";
  let t4;
  if ($[5] !== diff.to || $[6] !== t || $[7] !== t3) {
    t4 = t("ontologies.diff", {
      from: t3,
      to: diff.to
    });
    $[5] = diff.to;
    $[6] = t;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <SectionHead action={t2}>{t4}</SectionHead>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== diff.added) {
    t6 = diff.added.map(_temp3);
    $[12] = diff.added;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== diff.refused) {
    t7 = diff.refused.map(_temp4);
    $[14] = diff.refused;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== diff.added.length || $[17] !== diff.refused.length || $[18] !== t) {
    t8 = !diff.added.length && !diff.refused.length && <li className="muted">{t("ontologies.noChanges")}</li>;
    $[16] = diff.added.length;
    $[17] = diff.refused.length;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <ul className="pkg-lines mono">{t6}{t7}{t8}</ul>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== diff.hooks || $[25] !== diff.refused.length || $[26] !== p || $[27] !== t) {
    t10 = diff.refused.length > 0 ? <ErrorLine>{t("ontologies.refused")}</ErrorLine> : <>{diff.hooks.length > 0 && <label className="consent"><input type="checkbox" data-t="consent" checked={p.consent} onChange={e => p.setConsent(e.target.checked)} /><span>{t("ontologies.consent", {
            n: diff.hooks.length
          })}</span></label>}<Group><li><Row t="install" label={p.busy ? "…" : p.label} disabled={p.busy || diff.hooks.length > 0 && !p.consent} onClick={p.onInstall} /></li></Group></>;
    $[24] = diff.hooks;
    $[25] = diff.refused.length;
    $[26] = p;
    $[27] = t;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t5 || $[31] !== t9) {
    t11 = <div className="pkg-diff" data-t="diff">{t5}{t9}{t10}</div>;
    $[29] = t10;
    $[30] = t5;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}

/** One package: kinds, and install/upgrade with the diff preview. */
function _temp4(r) {
  return <li key={r.name} className="refused">✕ {r.name} <span className="muted">{r.reason}</span></li>;
}
function _temp3(a, i) {
  return <li key={`${a.name}${i}`} className="add" data-what={a.what}>+ {a.what} {a.name}{a.detail && <span className="muted"> {a.detail}</span>}</li>;
}
export function PackageView({
  name
}: {
  name: string;
}) {
  const {
    t
  } = useTranslation();
  // on a connected instance's page (/settings/instances/<name>/ontologies): its package, read-only
  const param = useParams().instance;
  const home = useHome();
  const remote = param && home && param !== home ? param : undefined;
  const pkgs = useLoad(() => api.ontologies.list(remote), `packages:${remote ?? ""}`, {
    kinds: ONTOLOGY_KINDS
  });
  const pkg = pkgs.data?.find(p => p.name === name) ?? null;
  const [diff, setDiff] = useState<PackageDiff | null>(null);
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!pkg) return pkgs.error ? <ErrorLine>{pkgs.error}</ErrorLine> : <Loader on={pkgs.loading} />;
  const upgrade = pkg.installed && pkg.installed !== pkg.version;
  const preview = async () => {
    setError(null);
    try {
      setDiff(await api.ontologies.preview(pkg.name, pkg.version));
    } catch (e) {
      setError(errorText(e));
    }
  };
  const install = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.ontologies.install(pkg.name, pkg.version, consent);
      setDiff(null);
      emitLive("truss.Ontology", pkg.name); // every list of packages on screen reloads
    } catch (e_0) {
      setError(errorText(e_0));
    } finally {
      setBusy(false);
    }
  };
  return <div data-t="package" data-id={pkg.name}>
			{pkg.description && <div className="body">{pkg.description}</div>}
			<Group>
				<Item label={t("ontologies.version")} value={pkg.version} mono />
				<Item label={t("ontologies.installedVersion")} value={pkg.installed ?? "—"} mono />
				{pkg.installedAt && <Item label={t("ontologies.installedAt")} value={pkg.installedAt.slice(0, 10)} mono />}
				{pkg.hooks.length > 0 && <Item label={t("ontologies.hooks")} value={pkg.hooks.length} />}
			</Group>
			{!remote && (!pkg.installed || upgrade) && !diff && <Group>
					<li>
						<Row t="preview" label={upgrade ? t("ontologies.upgrade") : t("ontologies.install")} chevron onClick={() => void preview()} />
					</li>
				</Group>}
			{diff && <DiffBlock diff={diff} consent={consent} setConsent={setConsent} busy={busy} label={upgrade ? t("ontologies.upgrade") : t("ontologies.install")} onClose={() => setDiff(null)} onInstall={() => void install()} />}
			{error && <ErrorLine>{error}</ErrorLine>}
			<SectionHead>{t("ontologies.kinds")}</SectionHead>
			<Group t="kinds">
				{pkg.kinds.map(k => <Stack key={k.name} data-kind={k.name} title={<span className="mono">{shortKind(k.name)}</span>} value={k.count ?? undefined} sub={<div>
								{k.description && <div>{k.description}</div>}
								<div className="mono">
									{k.fields.map(f => `${f.name}${f.required ? "" : "?"}: ${f.type}`).join(" · ")}
									{k.relations.length > 0 && ` · ${k.relations.map(r => `${r.name} → ${shortKind(r.to)}${r.many ? "[]" : ""}`).join(" · ")}`}
								</div>
							</div>} />)}
			</Group>
			{pkg.hooks.length > 0 && <>
					<SectionHead>{t("ontologies.hooks")}</SectionHead>
					<Group>
						{pkg.hooks.map(h => <Item key={h} label={<span className="mono">{h}</span>} value="" />)}
					</Group>
				</>}
		</div>;
}